import { getLocaleNames, useLocaleProvider } from "@aet/i18n"
import { tw } from "@aet/tailwind/macro"
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react"
import { Languages } from "lucide-react"

import { ICON_SIZE } from "../../projects/har/utils"

const LocaleIcon = tw.div`w-4 text-center font-mono`

const available = getLocaleNames(["en", "fr", "ja", "pt", "zh-HK"]) as [string, string][]

// https://source.chromium.org/chromium/chromium/src/+/main:third_party/devtools-frontend/src/front_end/core/i18n/locales/zh-HK.json
export function LocaleSwitch() {
  const { setLocale, locale } = useLocaleProvider()

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button disableRipple isIconOnly title="Locale" variant="light">
          <Languages size={ICON_SIZE} />
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        disallowEmptySelection
        aria-label="Locale switch"
        selectedKeys={[locale]}
        selectionMode="single"
        onSelectionChange={id => id.currentKey && setLocale(id.currentKey)}
      >
        {available.map(([locale, name]) => (
          <DropdownItem
            key={locale}
            lang={locale}
            startContent={<LocaleIcon>{locale.slice(0, 2)}</LocaleIcon>}
          >
            {name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}
